"use client";

import { motion } from "framer-motion";

import { DEFAULT_DURATION } from "@/lib/animation";

import { activities } from "./activities.data";
import ActivitiesCard from "./ActivitiesCard";
import styles from "./ActivitiesSection.module.scss";

export default function ActivitiesSection() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* TOP HEADING */}
        <motion.div
          className={styles.heading}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{
            duration: DEFAULT_DURATION,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          <p>Inspiring Moments, Driven</p>
          <p>by Kia</p>

          <h2>Supporting Football for All</h2>

          <span>
            Kia stands with every generation that loves football,
            supporting moments of the game as they unfold on stages
            around the world.
          </span>
        </motion.div>

        {/* FIRST ROW */}
        <div className={styles.grid}>
          <ActivitiesCard {...activities[0]!} />
          <ActivitiesCard {...activities[1]!} />
        </div>

        {/* SECOND TEXT BLOCK */}
        <div className={styles.secondSection}>
            <motion.div
                className={styles.secondHeading}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1],
                }}
            >
                <h2>Joy Beyond the Stadium</h2>

                <p>
                Kia engages with fans beyond the stadium, sharing the joy of football
                as part of everyday life.
                </p>
            </motion.div>

            <div className={styles.grid}>
                <ActivitiesCard {...activities[2]!} />
                <ActivitiesCard {...activities[3]!} />
            </div>
        </div>
      </div>
    </section>
  );
}